import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { ContextualMenuComponent } from 'src/app/controls/contextual-menu/contextual-menu.component';
import { ContextualMenuChange } from 'src/app/controls/contextual-menu/models/contextual-menu-change';
import { DefaultTreeItemComponent } from 'src/app/controls/default-composant/default-tree-item/default-tree-item.component';
import { Culture } from 'src/app/models/culture';
import { Rights } from 'src/app/models/enums/rights';
import { Role } from 'src/app/models/role';
import { User } from 'src/app/models/user';
import { MemoryService } from 'src/app/services/memory.service';
import { ContextualMenuComponent as ContextualMenuComponent_1 } from '../../../controls/contextual-menu/contextual-menu.component';

import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-user-tree-item',
    templateUrl: './user-tree-item.component.html',
    styleUrls: ['./user-tree-item.component.scss'],
    imports: [MatIconModule, ContextualMenuComponent_1]
})
export class UserTreeItemComponent extends DefaultTreeItemComponent<User> implements OnInit {
    /**
     * Instance de l'utilisateur affiché par le noeud courant.
     */
    @Input() user: User;

    /**
     * Liste de l'ensemble des rôles.
     * Utilisé pour afficher le libellé du rôle de l'utilisateur.
     */
    @Input() roles: Role[];

    /**
     * Liste de l'ensemble des langues.
     * Utilisé pour afficher le libellé de la langue de l'utilisateur.
     */
    @Input() cultures: Culture[];

    /**
     * Libellé du rôle de l'utilisateur courant
     */
    public roleName: string;

    /**
     * Libellé de la langue de l'utilisateur courant
     */
    public cultureLabel: string;

    /**
     * Valeur indiquant si l'id est affiché.
     */
    public isIdVisible: boolean;

    /**
     * Réference au composant du menu contextuel.
     */
    @ViewChild(ContextualMenuComponent, { static: false })
    contextuelMenu: ContextualMenuComponent<User, MenuITemAction>;

    /**
     * Constructeur.
     * @param dialog Boite de dialogue.
     * @param memoryService Service pour acceder aux infos de la session.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService
    ) {
        super(dialog, memoryService);

        this.isIdVisible = this.memoryService.getConnectedUser().params.idVisible === true;

        // Spécifie les éléments du menu contextuel en fonction des droits utilisateur

        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.GroupAndUserEdit);
        this.AddMenuItem('Réinitialiser', MenuITemAction.Reset, Rights.GroupAndUserEdit);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.determineRoleName();
        this.determineCultureLabel();
    }

    /**
     * Détermine le nom du rôle attribué au groupe courant.
     */
    private determineRoleName() {
        if (!!this.roles) {
            var userRoles = this.roles.filter((x) => this.user.roles.findIndex((r) => r === x.id) != -1);
            this.roleName = userRoles.map((x) => x.name).join(',');
        }
    }

    /**
     * Détermine le libellé de la langue de l'utilisateur courant.
     */
    private determineCultureLabel() {
        if (!!this.cultures) {
            this.cultureLabel = this.cultures.find((x) => x.code === this.user.culture)?.label;
        }
    }

    /**
     * Affiche le menu contextuel de l'utilisateur courant.
     * @param event : Événement souris.
     * @param group : Utilisateur pour lequel le menu contextuel doit être affiché.
     */
    public displayContextualMenu(event: MouseEvent, row: User) {
        this.contextuelMenu.open(event, row);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement indiquant l'élément du menu contextuel cliqué.
     */
    public onMenuChanged(event: ContextualMenuChange<User, MenuITemAction>) {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(this.user);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(this.user);
        } else if (event.action == MenuITemAction.Reset) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de réinitialiser l'utilisateur '${event.context.displayName}'.`, event.context);
        }
    }

    /**
     * Raffraichit l'affichage de cet utilisateur s'il correspond à l'id spécifié.
     * @param userId : Id de l'utilisateur à raffraichir.
     */
    public refreshUser(userId: string) {
        if (this.user.id === userId) {
            this.reload();
        }
    }

    private reload() {
        // TODO
    }
}
